import React from 'react';
export function Footer() {
  return <footer className="py-8 border-t border-white/10 bg-[#0D1117] relative z-10" data-id="element-65">
      <div className="container mx-auto px-6 text-center" data-id="element-66">
        <p className="text-gray-500 text-sm" data-id="element-67">
          Colección Profesional de Perfiles de Aluminio &copy;{' '}
          {new Date().getFullYear()}
        </p>
        <p className="text-gray-600 text-xs mt-2" data-id="element-68">
          Todos los derechos reservados
        </p>
      </div>
    </footer>;
}